import AddToCart from "../Elements/AddToCart";

export default function QuickAdd({competition}) {

	const baseQuantities = [25, 50, 75, 100];
	const quantities = baseQuantities.filter(qty => qty <= competition.stock && qty <= competition.max_tickets);

	// Fallback to stock OR max tickets, lower value.
	if (quantities.length === 0) {
		quantities.push( Math.min( competition.stock, competition.max_tickets ) );
	}

	return (
		<div className="zap-checkout-block-quick-add">
			<div className="zap-checkout-block-quick-add-item">
				<div className="zap-checkout-block-quick-add-item-thumbnail">
					<a href={competition.product_url} target="_blank" rel="noreferrer">
						<img src={competition.product_image} alt={competition.product_title} width="80"/>
					</a>
				</div>
				<div>
					<h3 className="zap-checkout-block-quick-add-item-title">
						<a href={competition.product_url} target="_blank" rel="noreferrer">
							{competition.product_title}
						</a>
					</h3>
					<div className="zap-checkout-block-quick-add-item-price">
						<strong className="price-value">{competition.product_price} </strong>
						<span className="price-suffix">Per Entry</span>
					</div>
				</div>
			</div>
			<div>
				<h4>Quick add to basket</h4>
				<div className="zap-checkout-block-quick-add-item-buttons">
					{quantities.map(qty => (
						qty <= competition.stock && qty <= competition.max_tickets && (
							<AddToCart competition={competition} qty={qty}>
								<div className="qty">{qty}</div>
								Tickets
							</AddToCart>)
					))}
				</div>
			</div>
		</div>
	);
}